const rootId = "root";
/** The element that the application is rendered in */
export const appRootElement = document.getElementById(rootId);
